import React from "react";
import Layout from "layouts";
import FlavoursComponent from "./FlavoursComponent";

export default function Flavours() {
  return (
    <Layout breadCrumb={[{ label: "Flavour", to: "#" }]}>
      <FlavoursComponent />
    </Layout>
  );
}
